module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('h1', {
    staticClass: "•-CH-TITLE-8-4-2015",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("TABLE OF CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer065"
    }
  }, [_c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test2#_idTextAnchor002"
    }
  }, [_vm._v("A Word from Bob")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test3#_idTextAnchor003"
    }
  }, [_vm._v("Editor’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test6#_idTextAnchor005"
    }
  }, [_vm._v("PROLOGUE: The First Grandchild")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test8#_idTextAnchor006"
    }
  }, [_vm._v("ACT ONE. 2004: Annus Notabilis")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test9#_idTextAnchor007"
    }
  }, [_vm._v("1. The Biggest Deal of All")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test13#_idTextAnchor008"
    }
  }, [_vm._v("2. The Fierce Determination of a Grandmother")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test17#_idTextAnchor009"
    }
  }, [_vm._v("3. “OK, I’ll Make It $25 Million.” The Bernie Marcus Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test20#_idTextAnchor010"
    }
  }, [_vm._v("4. Reflections on Success")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test23#_idTextAnchor011"
    }
  }, [_vm._v("ACT TWO. 1969–2012: Corporate Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test24#_idTextAnchor012"
    }
  }, [_vm._v("5. First Days")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test28#_idTextAnchor013"
    }
  }, [_vm._v("6. Media Baptism by Fire: Cox Cable")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test32#_idTextAnchor014"
    }
  }, [_vm._v("7. This Thing Called Cable")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test36#_idTextAnchor015"
    }
  }, [_vm._v("8. Chuck Dolan, Cablevision, and Me")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test40#_idTextAnchor016"
    }
  }, [_vm._v("9. The Business of CNBC")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test44#_idTextAnchor017"
    }
  }, [_vm._v("10. Rebuilding After a Firestorm: The Dateline Fiasco")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test48#_idTextAnchor018"
    }
  }, [_vm._v("11. Creating the Must-See TV Money Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test52#_idTextAnchor019"
    }
  }, [_vm._v("12. Travels with Johnny Carson")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test56#_idTextAnchor020"
    }
  }, [_vm._v("13. The Ted Turner Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test61#_idTextAnchor021"
    }
  }, [_vm._v("14. Olympic Gold")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test65#_idTextAnchor022"
    }
  }, [_vm._v("15. NBC + Microsoft = MSNBC")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test69#_idTextAnchor023"
    }
  }, [_vm._v("16. Dante’s Inferno: The Queen Mary 2 Became the Exxon Valdez!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test73#_idTextAnchor024"
    }
  }, [_vm._v("17. Rebooting Network-Affiliate Relations")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test77#_idTextAnchor025"
    }
  }, [_vm._v("18. Leaving NBC and GE")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test80#_idTextAnchor026"
    }
  }, [_vm._v("19. Comcast Takes Over")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test83#_idTextAnchor027"
    }
  }, [_vm._v("20. My Roller-Coaster Ride with Jack Welch")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test87#_idTextAnchor028"
    }
  }, [_vm._v("21. Suzanne: My Life’s Partner")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test88"
    }
  }, [_c('span', {
    staticClass: "CharOverride-28"
  }, [_vm._v("Act Three.")]), _vm._v(" 2004–Now: Nonprofit Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test90#_idTextAnchor029"
    }
  }, [_vm._v("22. 1 in 166: The Hidden Epidemic")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test94#_idTextAnchor030"
    }
  }, [_vm._v("23. Building from Scratch, Block by Block")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test98#_idTextAnchor031"
    }
  }, [_vm._v("24. Building Block #1: Global Expansion")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test102#_idTextAnchor032"
    }
  }, [_vm._v("25. Building Block #2: Political Muscle")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test105#_idTextAnchor033"
    }
  }, [_vm._v("26. Building Block #3: Grassroots Strength")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test109#_idTextAnchor034"
    }
  }, [_vm._v("27. Building Block #4: Business Principles")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test112#_idTextAnchor035"
    }
  }, [_vm._v("28. Building Block #5: Strategic Alliances")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test116#_idTextAnchor036"
    }
  }, [_vm._v("29. The Future for Autism Families")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test119#_idTextAnchor037"
    }
  }, [_vm._v("30. Vaccines and Other Controversies: A House Divided")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test122#_idTextAnchor038"
    }
  }, [_vm._v("31. MSSNG: From Beijing to Google")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test126#_idTextAnchor039"
    }
  }, [_vm._v("EPILOGUE: Christian at Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test129#_idTextAnchor040"
    }
  }, [_vm._v("APPENDIX A: NBCU")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test130#_idTextAnchor041"
    }
  }, [_vm._v("Vintage Wright: What Next?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test134#_idTextAnchor042"
    }
  }, [_vm._v("Some Deal Hits, Some Misses")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test137#_idTextAnchor043"
    }
  }, [_vm._v("Where Are They Now?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test140#_idTextAnchor044"
    }
  }, [_vm._v("APPENDIX B: AUTISM")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC TOCindent"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test141#_idTextAnchor045"
    }
  }, [_vm._v("What We’ve Learned About Autism")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test144#_idTextAnchor046"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/ebook__test147#_idTextAnchor046"
    }
  }, [_vm._v("The Wright Photography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-220361ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ebook_-_test-4.vue
// module id = 69
// module chunks = 0